export function calculateMaxY(lines, chartData) {
    if (!Array.isArray(lines) || !Array.isArray(chartData)) return 0;

    let maxY = 0;

    for (const row of chartData) {
        for (const key of lines) {
            const rawValue = row[key];
            const num = Number(rawValue);
            if (!isNaN(num) && isFinite(num)) {
                maxY = Math.max(maxY, num);
            }
        }
    }

    return maxY;
}

export function roundUpToNiceNumber(value) {
    if (!value || isNaN(value)) return 0;
    const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
    return Math.ceil(value / magnitude) * magnitude;
}

